import { Link } from "gatsby";
import React, { useState } from "react";
import * as s from "./mobile-menu.module.css";

const MobileNav = ({ menuItems, toggled }) => {
  const [opened, setOpened] = useState([]);
  const listedItems = menuItems.filter((val) => val.isListed);
  const navItems = menuItems.filter((val) => !val.isListed);
  const toggleSubMenu = (i) => {
    let newOpened;
    if (isOpened(i)) {
      newOpened = opened.filter((o) => o !== i);
    } else {
      newOpened = [...opened, i];
    }
    setOpened(newOpened);
  };

  const isOpened = (i) => {
    return opened.some((o) => o === i);
  };
  return (
    !!toggled && (
      <div className={s.mobileNav}>
        <div className={s.listedItemsWrapper}>
          <div className={`d-flex flex-column pb-4`}>
            {listedItems.map((mi, i) => {
              let hasSubMenu =
                (!!mi?.childItems &&
                  !!mi?.hierarchyDepth &&
                  mi?.hierarchyDepth == "two" &&
                  mi?.childItems.length > 0) ||
                (!!mi?.childItemsThree &&
                  !!mi?.hierarchyDepth &&
                  mi?.hierarchyDepth == "three" &&
                  mi?.childItemsThree.length > 0);
              return (
                <div
                  key={`header-menu-item-${i}`}
                  className={`${isOpened(i) ? s.opened : ""} ${s.menuItem} ${
                    hasSubMenu ? s.hasSubmenu : ""
                  } mb-1`}
                >
                  {hasSubMenu && (
                    <>
                      <div
                        className={s.submenuHeader}
                        onClick={() => {
                          toggleSubMenu(i);
                        }}
                        role="button"
                        aria-expanded={isOpened(i)}
                        aria-controls={`submenu-${i}`}
                      >
                        {!!mi?.parentItem?.link?.target &&
                        mi?.parentItem?.link?.target === "_blank" ? (
                          <a
                            href={mi?.parentItem?.link?.url}
                            rel="noreferrer"
                            target="_blank"
                            className={s.parentLink}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {mi?.parentItem?.link?.title}
                          </a>
                        ) : (
                          <Link
                            to={mi?.parentItem?.link?.url}
                            className={s.parentLink}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {mi?.parentItem?.link?.title}
                          </Link>
                        )}
                        <span
                          className={s.toggleIcon}
                          aria-hidden
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubMenu(i);
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6 9l6 6 6-6"
                              stroke="currentColor"
                              strokeWidth="2"
                            />
                          </svg>
                        </span>
                      </div>
                      <div id={`submenu-${i}`} className={`${s.subMenu}`}>
                        {mi?.hierarchyDepth == "two" &&
                          mi.childItems.map((smi, j) => (
                            <div
                              key={`header-submenu-item-${i}-${j}`}
                              className={`${s.menuItem}`}
                            >
                              {!!smi?.link && (
                                <Link to={smi.link.url}>
                                  {smi?.link?.title}
                                </Link>
                              )}
                              {!smi?.link && <span>{smi?.link?.title}</span>}
                            </div>
                          ))}
                        {mi?.hierarchyDepth == "three" &&
                          mi.childItemsThree.map((smi, j) => (
                            <div
                              key={`header-submenu-item-${i}-${j}`}
                              className={`${s.menuItem}`}
                            >
                              {!!smi?.parentLink && (
                                <Link to={smi.parentLink.url}>
                                  {smi?.parentLink?.title}
                                </Link>
                              )}
                              {!smi?.parentLink && (
                                <span>{smi?.parentLink?.title}</span>
                              )}
                              <div className={s.thirdlLevelSub}>
                                {!smi.dontShowChild &&
                                  smi.childs.map((ssmi, k) => (
                                    <div
                                      key={`header-submenu-item-${i}-${j}-${k}`}
                                      className={`${s.menuItem}`}
                                    >
                                      {!!ssmi?.link && (
                                        <Link to={ssmi.link.url}>
                                          {ssmi?.link?.title}
                                        </Link>
                                      )}
                                      {!ssmi?.link && (
                                        <span>{ssmi?.link?.title}</span>
                                      )}
                                    </div>
                                  ))}
                              </div>
                            </div>
                          ))}
                      </div>
                    </>
                  )}
                  {!hasSubMenu && !!mi.parentItem && (
                    <>
                      {!!mi.target && mi.target === "_blank" && (
                        <a
                          href={mi?.parentItem?.link?.url}
                          rel="noreferrer"
                          target="_blank"
                          className={s.parentLink}
                        >
                          {mi?.parentItem?.link?.title}
                        </a>
                      )}
                      {!mi?.parentItem?.link?.target && (
                        <Link
                          to={mi?.parentItem?.link?.url}
                          className={s.parentLink}
                        >
                          {mi?.parentItem?.link?.title}
                        </Link>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className={s.divider}></div>
        <div className={s.navItemsWrapper}>
          <div className={`d-flex flex-column`}>
            {navItems.map((mi, i) => {
              return (
                <div
                  key={`header-menu-item-${i}`}
                  className={`${s.navMenuItem}`}
                >
                  {!!mi.parentItem && (
                    <>
                      {!!mi.target && mi.target === "_blank" && (
                        <a
                          href={mi?.parentItem?.link?.url}
                          rel="noreferrer"
                          target="_blank"
                          className={s.parentLink}
                        >
                          {mi?.parentItem?.link?.title}
                        </a>
                      )}
                      {!mi?.parentItem?.link?.target && (
                        <Link
                          to={mi?.parentItem?.link?.url}
                          className={s.parentLink}
                        >
                          {mi?.parentItem?.link?.title}
                        </Link>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className={s.divider}></div>
        <div className={s.socialWrapper}>
          <a
            href="https://www.instagram.com/the.houseoflife/"
            rel="noreferrer"
            target="_blank"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 2.52109C17.7406 2.52109 18.1836 2.5375 19.6547 2.60312C21.0219 2.66328 21.7602 2.89297 22.2523 3.08438C22.9031 3.33594 23.3734 3.64219 23.8602 4.12891C24.3523 4.62109 24.6531 5.08594 24.9047 5.73672C25.0961 6.22891 25.3258 6.97266 25.3859 8.33438C25.4516 9.81094 25.468 10.2539 25.468 13.9891C25.468 17.7297 25.4516 18.1727 25.3859 19.6438C25.3258 21.0109 25.0961 21.7492 24.9047 22.2414C24.6531 22.8922 24.3469 23.3625 23.8602 23.8492C23.368 24.3414 22.9031 24.6422 22.2523 24.8938C21.7602 25.0852 21.0164 25.3148 19.6547 25.375C18.1781 25.4406 17.7352 25.457 14 25.457C10.2594 25.457 9.81641 25.4406 8.34531 25.375C6.97813 25.3148 6.23984 25.0852 5.74766 24.8938C5.09688 24.6422 4.62656 24.3359 4.13984 23.8492C3.64766 23.357 3.34687 22.8922 3.09531 22.2414C2.90391 21.7492 2.67422 21.0055 2.61406 19.6438C2.54844 18.1672 2.53203 17.7242 2.53203 13.9891C2.53203 10.2484 2.54844 9.80547 2.61406 8.33438C2.67422 6.96719 2.90391 6.22891 3.09531 5.73672C3.34687 5.08594 3.65313 4.61563 4.13984 4.12891C4.63203 3.63672 5.09688 3.33594 5.74766 3.08438C6.23984 2.89297 6.98359 2.66328 8.34531 2.60312C9.81641 2.5375 10.2594 2.52109 14 2.52109ZM14 0C10.1992 0 9.72344 0.0164062 8.23047 0.0820313C6.74297 0.147656 5.72031 0.388281 4.83437 0.732813C3.91016 1.09375 3.12813 1.56953 2.35156 2.35156C1.56953 3.12813 1.09375 3.91016 0.732812 4.82891C0.388281 5.72031 0.147656 6.7375 0.0820313 8.225C0.0164063 9.72344 0 10.1992 0 14C0 17.8008 0.0164063 18.2766 0.0820313 19.7695C0.147656 21.257 0.388281 22.2797 0.732812 23.1656C1.09375 24.0898 1.56953 24.8719 2.35156 25.6484C3.12813 26.425 3.91016 26.9063 4.82891 27.2617C5.72031 27.6063 6.7375 27.8469 8.225 27.9125C9.71797 27.9781 10.1937 27.9945 13.9945 27.9945C17.7953 27.9945 18.2711 27.9781 19.7641 27.9125C21.2516 27.8469 22.2742 27.6063 23.1602 27.2617C24.0789 26.9063 24.8609 26.425 25.6375 25.6484C26.4141 24.8719 26.8953 24.0898 27.2508 23.1711C27.5953 22.2797 27.8359 21.2625 27.9016 19.775C27.9672 18.282 27.9836 17.8063 27.9836 14.0055C27.9836 10.2047 27.9672 9.72891 27.9016 8.23594C27.8359 6.74844 27.5953 5.72578 27.2508 4.83984C26.9062 3.91016 26.4305 3.12813 25.6484 2.35156C24.8719 1.575 24.0898 1.09375 23.1711 0.738281C22.2797 0.39375 21.2625 0.153125 19.775 0.0875C18.2766 0.0164063 17.8008 0 14 0Z"
                fill="white"
              />
              <path
                d="M14 6.80859C10.0297 6.80859 6.80859 10.0297 6.80859 14C6.80859 17.9703 10.0297 21.1914 14 21.1914C17.9703 21.1914 21.1914 17.9703 21.1914 14C21.1914 10.0297 17.9703 6.80859 14 6.80859ZM14 18.6648C11.4242 18.6648 9.33516 16.5758 9.33516 14C9.33516 11.4242 11.4242 9.33516 14 9.33516C16.5758 9.33516 18.6648 11.4242 18.6648 14C18.6648 16.5758 16.5758 18.6648 14 18.6648Z"
                fill="white"
              />
              <path
                d="M23.1547 6.52417C23.1547 7.45386 22.4 8.20308 21.4758 8.20308C20.5461 8.20308 19.7969 7.44839 19.7969 6.52417C19.7969 5.59448 20.5516 4.84526 21.4758 4.84526C22.4 4.84526 23.1547 5.59995 23.1547 6.52417Z"
                fill="white"
              />
            </svg>
          </a>
          {/* {<a href="#" rel="noreferrer"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_114_1142)">
            <path d="M8.80852 25.375C19.372 25.375 25.1513 16.6212 25.1513 9.03222C25.1513 8.78612 25.1459 8.53456 25.1349 8.28847C26.2592 7.47542 27.2294 6.46834 28 5.31456C26.9529 5.78041 25.8412 6.08466 24.7029 6.2169C25.9015 5.49844 26.799 4.36976 27.2289 3.04011C26.1013 3.70836 24.8682 4.17976 23.5823 4.43409C22.716 3.51353 21.5705 2.90401 20.323 2.69977C19.0754 2.49553 17.7954 2.70794 16.6807 3.30416C15.566 3.90038 14.6788 4.8472 14.1562 5.99824C13.6335 7.14928 13.5047 8.44043 13.7895 9.67206C11.5062 9.55748 9.27259 8.96437 7.23331 7.93116C5.19403 6.89795 3.39464 5.44772 1.9518 3.67448C1.21847 4.93883 0.994066 6.43497 1.3242 7.85882C1.65434 9.28267 2.51424 10.5274 3.72914 11.34C2.81707 11.3111 1.92497 11.0655 1.12656 10.6236V10.6947C1.12575 12.0216 1.58445 13.3077 2.42469 14.3346C3.26494 15.3615 4.43488 16.0657 5.73562 16.3275C4.89073 16.5587 4.00398 16.5924 3.14398 16.426C3.51103 17.5671 4.22517 18.5651 5.18673 19.2808C6.1483 19.9965 7.30931 20.3941 8.50773 20.4182C6.47316 22.0163 3.95987 22.8832 1.37266 22.8791C0.913835 22.8784 0.455466 22.8503 0 22.7949C2.62833 24.4811 5.68579 25.3767 8.80852 25.375Z" fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_114_1142">
              <rect width="28" height="28" fill="white" />
            </clipPath>
          </defs>
        </svg>
        </a>} */}
          <a
            href="https://www.facebook.com/firsthouseoflife"
            rel="noreferrer"
            target="_blank"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_114_1144)">
                <path
                  d="M28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 20.9877 5.11957 26.7796 11.8125 27.8299V18.0469H8.25781V14H11.8125V10.9156C11.8125 7.40688 13.9027 5.46875 17.1005 5.46875C18.6318 5.46875 20.2344 5.74219 20.2344 5.74219V9.1875H18.4691C16.73 9.1875 16.1875 10.2668 16.1875 11.375V14H20.0703L19.4496 18.0469H16.1875V27.8299C22.8804 26.7796 28 20.9877 28 14Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_114_1144">
                  <rect width="28" height="28" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a
            href="https://www.linkedin.com/company/houseoflife"
            rel="noreferrer"
            target="_blank"
          >
            <svg
              width="28"
              height="28"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"
                fill="white"
              />
            </svg>
          </a>
          <a
            href="https://youtube.com/@1sthouseoflife"
            rel="noreferrer"
            target="_blank"
          >
            <svg
              width="28"
              height="28"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
            >
              <path
                d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"
                fill="white"
              />
            </svg>
          </a>
        </div>
      </div>
    )
  );
};

export default MobileNav;
